import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SharedService } from './shared.service';
import { ContentCriteria } from '../common';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  constructor(private http: HttpClient) { }

  // operator
  async getList(criteria: ContentCriteria, from = 0, limit = 20) {
    return this.http.post<{ contents: any[], total: number }>(environment.app.apiUrl + 'content/list', { criteria, from, limit }).toPromise();
  }

  // operator
  delete(id: string) {
    return this.http.delete(environment.app.apiUrl + 'content/' + id).toPromise();
  }

  // operator
  async save(content: any, imageOrRemoveImage?: File | boolean) {
    const formData = new FormData();
    const removeImage = imageOrRemoveImage == true;
    if (imageOrRemoveImage instanceof File) { formData.append('image', imageOrRemoveImage, imageOrRemoveImage.name); }
    formData.append('content', JSON.stringify(content));
    return this.http.post(environment.app.apiUrl + 'content/save', formData,
      { params: { removeImage: removeImage.toString() } }).toPromise();
  }

  async getSeoContents(what: string, where: string) {
    if (!what && !where)
      return null;
    return this.http.get<any[]>(environment.app.apiUrl + 'content', { params: { l: where || '', q: what || '' }, context: SharedService.NO_LOADING_BAR }).toPromise();
  }

  // operator
  get(id: string) {
    return this.http.get(environment.app.apiUrl + 'content/' + id).toPromise();
  }
}
